<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>    
    @if(electionOpen){
      <app-progress-bar [routeName]="routeName"></app-progress-bar>
      <main aria-label="form">
      @if(aboutService.idUploadFlow){
        <h1 id="main-title" class="vtz-h1" i18n>Log in</h1>
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          Please enter your email address and phone number.
      } @else {
        <h1 id="main-title" class="vtz-h1" i18n>Identity Verification</h1>
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          Please enter your information as it appears in your Voter Information Email. Do not include spaces.
      }
      <h2 class="vtz-text vtz-text--center vtz-text--bold">
        <strong><i i18n ><span class="vtz--red">*</span> indicates a required field.</i></strong>
      </h2>

      <form 
        (ngSubmit)="onSubmit()"
        [formGroup]="verificationForm"
        class="vtz-form"
      >
        @for (field of fields; track field; let i = $index) {
        <div class="vtz-form__row">
          @switch (field.fieldType) {
          <!------------------------------- DATE PICKER FIELD TYPE ------------------------------------------>
          @case ('date') {
          <div class="vtz-form__item">
            <app-date-picker tooltipText="{{field.fieldTooltip}}" htmlIdPrefix="{{field.fieldName}}"
              [dateParts]="dateField?.dateParts ?? defaultDateParts"></app-date-picker>
          </div>
          }
          <!------------------------------- PHONE FIELD TYPE ------------------------------------------------>
          @case (['phone','confirm_phone'].includes(field.fieldType) ? field.fieldType : '') {
          <div class="vtz-form__item">
            <label class="vtz-form__label" for="{{field.fieldName}}">
              <span i18n="Form field label">{{ field.fieldTitle }}</span>
              @if (field.isMandatory) {
              <span class="vtz--red">*</span>
              }
              @if (field.fieldTooltip !== undefined) {
              <button id="tooltip-{{field.fieldName}}"  class="vtz-tooltip"
                matTooltip="{{field.fieldTooltip}}" i18n-matTooltip="Tooltip information" matTooltipPosition="after"
                aria-label="Tooltip for input field"
                i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                (click)="onTooltipClick($event)"></button>
              }
            </label>
            <ngx-intl-tel-input id="{{ field.fieldName }}" [cssClass]="'vtz-form__input'"
              [preferredCountries]="[(aboutService.aboutInformation | async)!.country]" [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[
                        SearchCountryField.Iso2,
                        SearchCountryField.Name
                      ]" searchCountryPlaceholder="Search Country"
              i18n-searchCountryPlaceholder="Enter the name of a country to search for|appears in a phone number entry field, as a placeholder in a typeahead widget for selecting the country code"
              [selectFirstCountry]="false" [selectedCountryISO]="(aboutService.aboutInformation | async)!.country"
              [phoneValidation]="true" name="phone" inputId="{{ field.fieldName }}" [separateDialCode]="true"
              formControlName="{{ field.fieldName }}" (paste)="handlePaste($event)" [ngClass]="{ 'vtz-form__input--error':(verificationForm.controls[field.fieldName].touched &&
                        !verificationForm.controls[field.fieldName].valid) || (verificationForm.controls[field.fieldName].touched &&
                        verificationForm.controls[field.fieldName].errors?.required)}">
            </ngx-intl-tel-input>
            @if (
            verificationForm.controls[field.fieldName].touched &&
            verificationForm.controls[field.fieldName].errors?.required
            ) {
              <div role="alert">
                <span aria-live="assertive" class="vtz-form__error" i18n="Invalid form field">This field is required.
                </span>
              </div>

            }
            @if (
            field.fieldType === 'phone' &&
            verificationForm.controls[field.fieldName].touched &&
            !verificationForm.controls[field.fieldName].errors?.required &&
            !verificationForm.controls[field.fieldName].valid
            ) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Please enter a valid mobile number.
                </span>
              </div>
            }
            @if (
            field.fieldType === 'confirm_phone' &&
            verificationForm.controls[field.fieldName].touched &&
            !verificationForm.controls[field.fieldName].errors?.required &&
            verificationForm.controls[field.fieldName].errors?.notMatch
            ) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">The phone numbers do not match.</span>
              </div>
            }
          </div>
          }
          <!----------------------- IN-PERSON VOTING CENTER FIELD TYPE -------------------------------------->
          @case('voting_center') {
            <div class="vtz-form__item">
              <label class="vtz-form__label" for="{{field.fieldName}}">
                <span i18n="Form field label">{{ field.fieldTitle }}</span>
                @if (field.isMandatory) {
                  <span class="vtz--red">*</span>
                }
                @if (field.fieldTooltip !== undefined) {
                  <button id="tooltip-{{field.fieldName}}"  class="vtz-tooltip"
                    matTooltip="{{field.fieldTooltip}}" i18n-matTooltip="Tooltip information" matTooltipPosition="after"
                    aria-label="Tooltip for input field "
                    i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                    (click)="onTooltipClick($event)"></button>
                }
              </label>
              <select class="vtz-form__select" name="VotingCenter" id="voting_center" formControlName="VotingCenter">
                <option value="null" i18n>Select {{field.fieldTitle}}</option>
                @for(location of locations; track location) {
                  <option [value]="location.id">{{ location.name }}</option>
                }
              </select>
              @if (
                verificationForm.controls[field.fieldName].touched &&
                verificationForm.controls[field.fieldName].errors?.required &&
                field.isMandatory) {
                <div role="alert">
                  <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">{{ field.fieldTitle }} is required.</span>
                </div>
              }
              @if ( verificationForm.controls[field.fieldName].dirty &&
                verificationForm.controls[field.fieldName].errors?.pattern) {
                <div role="alert">
                  <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Please enter a valid {{field.fieldTitle}}.</span>
                </div>
              }
            </div>
          }
          <!------------------------------- DEFAULT FIELD TYPE ---------------------------------------------->
          @default {
          <div class="vtz-form__item">
            <label class="vtz-form__label" for="{{field.fieldName}}">
              <span i18n="Form field label">{{ field.fieldTitle }}</span>
              @if (field.isMandatory) {
              <span class="vtz--red">*</span>
              }
              @if (field.fieldTooltip !== undefined) {
              <button id="tooltip-{{field.fieldName}}"  class="vtz-tooltip"
                matTooltip="{{field.fieldTooltip}}" i18n-matTooltip="Tooltip information" matTooltipPosition="after"
                aria-label="Tooltip for input field "
                i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                (click)="onTooltipClick($event)"></button>
              }
            </label>
            <!--------------------------------------------------------------------------------------------->
            @if (field.isPin) {
              <div class="pin-special">
                <input class="vtz-form__input" autocomplete="off" [type]="hide ? 'password' : 'text'" type="text"
                  id="{{ field.fieldName }}" formControlName="{{ field.fieldName }}" name="{{ field.fieldName }}"
                  (paste)="handlePaste($event)"
                  [attr.aria-required]="field.isMandatory ? 'true' : null"
                  [attr.required]="field.isMandatory ? true : null" [attr.aria-label]="field.fieldTitle" [ngClass]="{ 'vtz-form__input--error': verificationForm.controls[field.fieldName].dirty &&
                  verificationForm.controls[field.fieldName].invalid}" />
                <mat-icon class="hide-show" aria-hidden="false" role="button" matSuffix (click)="hide = !hide">{{hide ?
                  'visibility_off' : 'visibility'}}</mat-icon>
              </div>
            } @else {
              <input class="vtz-form__input" autocomplete="off" type="text" id="{{ field.fieldName }}"
                formControlName="{{ field.fieldName }}" name="{{ field.fieldName }}"
                (paste)="handlePaste($event)"
                [attr.aria-required]="field.isMandatory ? 'true' : null" [attr.required]="field.isMandatory ? true : null"
                [attr.aria-label]="field.fieldTitle" [ngClass]="{ 'vtz-form__input--error': verificationForm.controls[field.fieldName].dirty &&
                  verificationForm.controls[field.fieldName].invalid}" />
            }
            @if (
            verificationForm.controls[field.fieldName].touched &&
            verificationForm.controls[field.fieldName].errors?.required &&
            field.isMandatory) {
            <div role="alert">
              <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">{{ field.fieldTitle }} is required.
              </span>
            </div>

            }
            @if (field.isPin &&
            verificationForm.controls[field.fieldName].dirty &&
            verificationForm.controls[field.fieldName].errors?.pattern) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Please enter a valid {{field.fieldTitle}}: only
                  letters and numbers.
                </span>
              </div>

            }
            @if (field.isPin &&
            verificationForm.controls[field.fieldName].dirty &&
            verificationForm.controls[field.fieldName].errors?.maxlength) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Maximum {{maxPINLength}} characters.
                </span>
              </div>

            }
            @if (
            verificationForm.controls[field.fieldName].touched &&
            verificationForm.controls[field.fieldName].errors?.invalidEmail) {
              <div role="alert">
                <span class="vtz-form__error" i18n="Invalid form field">Please enter a valid email address.
                </span>
              </div>
  
            }
            @if ( field.fieldType === 'email' &&
            verificationForm.controls[field.fieldName].dirty &&
            verificationForm.controls[field.fieldName].errors?.maxlength) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" id="email_too_long_error_message" i18n="Invalid form field">Maximum
                  {{maxEmailLength}} characters.
                </span>
              </div>

            }
            @if (field.fieldType === 'confirm_email' &&
            verificationForm.controls[field.fieldName].touched &&
            verificationForm.controls[field.fieldName].errors?.notMatch) {
              <div role="alert">
                <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">The emails do not match.
                </span>
              </div>

            }
          </div>
          }
          }
        </div>
        }
        @if(!aboutService.isVotingCenter()) {
          <ngx-invisible-recaptcha #captchaRef
            [siteKey]="recaptchaSiteKey"
            (success)="resolved($event)"
            (reset)="handleReset()"
            aria-hidden="true">
          </ngx-invisible-recaptcha>
        }
        <div class="vtz-actions">
          @if(routeToMfaScreen()){
            <button class="button button-primary" id="submit-continue" type="submit" i18n="Button label"
              [disabled]="!verificationForm.valid || !electionOpen || sessionService.activeSessionCheck()">CONTINUE</button>
          } @else {
            <button class="button button-primary" id="submit" type="submit" i18n="Button label"
              [disabled]="!verificationForm.valid || !electionOpen || sessionService.activeSessionCheck()">VERIFY</button>
          }
        </div>
      </form>
      @if (displaySpinner) {
        <div class="progressSpinner">
          <mat-spinner [diameter]="300" color="primary"></mat-spinner>
          <div class="spinner-warning">
            <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
          </div>
        </div>
      }
    </main>
    } @else if (aboutService.electionNotYetOpen || aboutService.registrationNotYetOpen) {
      <h1 id="main-title" class="vtz-h1" i18n>Election not open yet</h1>
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        The election will be open from {{aboutService.startTime}} to {{this.aboutService.endTime}}.
      </p>
    } @else {
      <h1 id="main-title" class="vtz-h1" i18n>Election Closed</h1>
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        The election was open from {{aboutService.startTime}} to {{aboutService.endTime}}.
      </p>
    }
  </div>
</div>
